
/**
 * Main phase analysis entry point
 */

import { PhaseAnalysisResult } from '../types';
import { analyzeProspectingPhase } from './prospecting';
import { analyzeExplorationPhase } from './exploration';
import { analyzeDevelopmentPhase } from './development';

export function preProductionPhaseAnalysis(
  phase: 'prospecting' | 'exploration' | 'development',
  projectData: any,
  marketData: any
): PhaseAnalysisResult {
  let phaseSpecificMetrics = {};
  let riskProfile = {};
  let valueDrivers: any[] = [];
  let milestoneProjections: any[] = [];
  let fundingRequirements = {};
  let probabilityOfSuccess = 0;
  
  switch (phase) {
    case 'prospecting':
      ({ phaseSpecificMetrics, riskProfile, valueDrivers, milestoneProjections, fundingRequirements, probabilityOfSuccess } = 
        analyzeProspectingPhase(projectData, marketData));
      break;
    case 'exploration':
      ({ phaseSpecificMetrics, riskProfile, valueDrivers, milestoneProjections, fundingRequirements, probabilityOfSuccess } = 
        analyzeExplorationPhase(projectData, marketData));
      break;
    case 'development':
      ({ phaseSpecificMetrics, riskProfile, valueDrivers, milestoneProjections, fundingRequirements, probabilityOfSuccess } = 
        analyzeDevelopmentPhase(projectData, marketData));
      break;
  }
  
  return {
    phaseSpecificMetrics,
    riskProfile,
    valueDrivers,
    milestoneProjections,
    fundingRequirements,
    probabilityOfSuccess
  };
}

// Re-export phase analysis functions for direct use
export { analyzeProspectingPhase } from './prospecting';
export { analyzeExplorationPhase } from './exploration';
export { analyzeDevelopmentPhase } from './development';
